import { MovieOpenMinusOutlineIcon } from './MovieOpenMinusOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 61DDE079-6865-4609-B2F6-2770A3A039E1
 * name movie-open-minus-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-open-minus-outline.svg
 * tags
 * - Video / Movie 
 */
export const SlateOpenMinusOutlineIcon = MovieOpenMinusOutlineIcon;
export default SlateOpenMinusOutlineIcon